import type { App } from 'vue';
import baseFr from '@nextories/vue-core-components/src/i18n/langs/fr/index';
import { createI18n } from 'vue-i18n';
import fr from "@/i18n/langs/fr/index";
import numberFormats from '@/i18n/numberFormats';
import dateTimeFormats from '@/i18n/dateTimeFormats';

export const i18n = createI18n({
	legacy: false,
	fallbackLocale: 'fr',
	warnHtmlMessage: false,
	locale: 'fr',
	allowComposition: true,
	numberFormats,	
	dateTimeFormats,
	messages: {
		fr: {
			...baseFr,
			...fr,
		},
	},
});
export const i18nPlugin = {
	install: (app: App) => {
		app.use(i18n);
	},
};

export default i18nPlugin;
